import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  admin,
  announce,
  announcement,
  apptime,
  arrow,
  help,
  history,
  link,
  logout,
  overall,
  recharge,
  report,
  side_bar,
  winning,
  withdraw,
  withdrawIcon,
} from "../assets/img";
import useStore from "../Screen/redux/store/useStore";
import { post } from "../Services/ApiHandler";
import { BASE_URL, ICON_FILTER, URLS } from "../Services/Constant";
import { Toast } from "./Toast";
// Firebase v9 imports
import { ref, onValue, off, set } from "firebase/database";
import { db } from "../Services/firebase";
import { Table } from "./Table/Table";
import { useAppContext } from "../Services/AppContext";
import axios from "axios";
import CommonPopup from "./CommonPopup";
import { PRIMARY_COLOR } from "../Services/Colors";

const ProfileNavbar = ({ setSaidList }) => {
  const [showMenu, setShowMenu] = useState(false);

  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setArrowEnable } = useAppContext();

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const currentPath =
    pathname.replace("/dashboard", "").replace("/", "") || "dashboard";

  const { role, user, permissions } = useStore();
  // console.log("permission list", permissions);
  // Set activeMenu based on currentPath on mount and path change
  useEffect(() => {
    const activeItem = profiledata.find((item) =>
      item.activePaths.includes(currentPath),
    );
    if (activeItem) {
      setActiveMenu(activeItem.module_code);
    }
  }, [currentPath]);

  useEffect(() => {
    //To store logFile into server
    const uploadLogCheck = ref(db, `/logFile/admin/${user?.id}`);

    onValue(uploadLogCheck, (snap) => {
      let d = snap.val();
      if (!d) return;
      // console.log("logfile firebase ref", d);
      if (d?.uploadLog) {
        uploadLogFile(uploadLogCheck);
      }
    });
    return () => {
      off(uploadLogCheck, "value");
    };
  }, []);

  const uploadLogFile = async (firebaseDbRef) => {
    let logFile = await window.getLogFile();
    let payload = new FormData();
    payload.append("file", logFile, `admin_${user?.id}_logfile.txt`);
    payload.append("user_id", `0${user?.id}`);
    console.log("logfile", logFile, user?.id, payload);
    try {
      const res = await axios.post(
        `${BASE_URL.replace("admin/", "")}${URLS.UPLOAD_LOG}`,
        payload,
      );
      // console.log("logfile upload", res);

      if (res?.data?.status === "success") {
        set(firebaseDbRef, { uploadLog: false, logUrl: res?.data?.url });
        window.clearLogs();
      }
    } catch (error) {
      console.log("uploading logfile", error);
    }
  };

  // ✅ Menu items mapped to module_code (from your backend permission data)
  const profiledata = [
    {
      icon: admin,
      title: "DASHBOARD",
      img: arrow,
      path: "/dashboard",
      module_code: "dashboard",
      activePaths: ["dashboard"],
    },
    {
      icon: admin,
      title: "ADMINS",
      img: arrow,
      path: "/admin",
      module_code: "admins",
      activePaths: ["admin", "admin-add"],
    },
    {
      icon: admin,
      title: "ROLES MAPPING",
      img: arrow,
      path: "/role",
      module_code: "role_maping",
      activePaths: ["role", "role-update"],
    },
    {
      icon: admin,
      title: "CLIENTS",
      img: arrow,
      path: "/client-list",
      module_code: "client",
      activePaths: ["client-list", "client-report"],
    },
    {
      icon: recharge,
      title: "ADMIN RECHARGE",
      img: arrow,
      path: "/admin-recharge",
      module_code: "admin_recharge",
      activePaths: ["admin-recharge"],
    },
    {
      icon: history,
      title: "RECHARGE HISTORY",
      img: arrow,
      path: "/recharge-history",
      module_code: "recharge_history",
      activePaths: ["recharge-history"],
    },
    {
      icon: withdrawIcon,
      title: "WITHDRAW HISTORY",
      img: arrow,
      path: "/withdraw-history",
      module_code: "widraw_history",
      activePaths: ["withdraw-history"],
    },
    {
      icon: announce,
      title: "ANNOUNCE RESULT",
      img: arrow,
      path: "/announce-result",
      module_code: "announce_result",
      activePaths: ["announce-result"],
    },
    {
      icon: overall,
      title: "OVERALL RESULTS",
      img: arrow,
      path: "/overall-result",
      module_code: "overall_result",
      activePaths: ["overall-result"],
    },
    {
      icon: report,
      title: "REPORTS",
      img: arrow,
      path: "/report",
      module_code: "reports",
      activePaths: ["report"],
    },
    {
      icon: overall,
      title: "COMMISSION HISTORY",
      img: arrow,
      path: "/commission",
      module_code: "commission_history",
      activePaths: ["commission"],
    },
    {
      icon: winning,
      title: "ANNOUNCEMENT",
      img: arrow,
      path: "/announcement",
      module_code: "announcements",
      activePaths: ["announcement"],
    },
    {
      icon: winning,
      title: "HOLIDAY UPDATE",
      img: arrow,
      path: "/holiday-update",
      module_code: "holiday_update",
      activePaths: ["holiday-update"],
    },
    {
      icon: link,
      title: "LINKS",
      img: arrow,
      path: "/add-link",
      module_code: "links",
      activePaths: ["add-link"],
    },
    {
      icon: overall,
      title: "LOT PRICE DETAILS",
      img: arrow,
      path: "/lot-price",
      module_code: "lot_price_details",
      activePaths: ["lot-price"],
    },
    {
      icon: overall,
      title: "PRICE DETAILS",
      img: arrow,
      path: "/cash-agency",
      module_code: "price_details",
      activePaths: ["cash-agency"],
    },
    {
      icon: apptime,
      title: "APP TIME SETTINGS",
      img: arrow,
      path: "/app-time",
      module_code: "app_time_setting",
      activePaths: ["app-time"],
    },
    {
      icon: help,
      title: "HELP & SUPPORT",
      img: arrow,
      path: "/help-support",
      module_code: "help_and_support",
      activePaths: ["help-support", "help-chat"],
    },
  ];

  // ✅ Dropdown items with permissions
  const dropdownItems = [
    { title: "DELETE DATA", path: "/delete-data", module_code: "delete_data" },
    {
      title: "CLIENT ACTIVITY",
      path: "/client-activity",
      module_code: "client_activity",
    },
    {
      title: "BLOCKED CLIENT LIST",
      path: "/blocked-client",
      module_code: "blocked_client_list",
    },
    {
      title: "DRAW STATUS",
      path: "/draw-status",
      module_code: "draw_status",
    },
  ];

  // ✅ Filter menu based on permissions
  const filteredMenu = profiledata.filter((item) => {
    // Admin & Super Admin → allow all
    if (role === true) {
      return true;
    }

    const hasPermission = permissions?.some(
      (p) => p.module_code === item.module_code,
    );

    return hasPermission;
  });

  const filteredDropdown = dropdownItems.filter((item) => {
    if (role === true) return true;

    const hasPermission = permissions?.some(
      (p) => p.module_code === item.module_code,
    );

    return hasPermission;
  });

  // console.log("ROLE VALUE =>", role);
  // console.log("PERMISSIONS =>", permissions);

  const toggleSidebar = () => {
    setArrowEnable(!saideBarShow);
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };

  useEffect(() => {
    console.log("saideBarShow changed:", saideBarShow);
    sessionStorage.setItem("saideBarShow", saideBarShow ? "true" : "false");
  }, [saideBarShow]);

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      const res = await post(URLS.LOGOUT);
      console.log("res logout", res);
      if (res.status === "success") {
        Toast(res.message || "Logout Successfully!");
      }
    } catch (err) {
      console.log("err logout", err);
    }
    setTimeout(() => {
      setLoading(false);
      setPopup(false);
      sessionStorage.clear();
      localStorage.removeItem("token");
      navigate("/", { replace: true });
    }, 1000);
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const dropdownRef = useRef(null);

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [menuOpen]);

  const handleCloseMenu = () => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setTimeout(() => setMenuOpen(false), 300); // wait for scroll then close
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <div
        style={{ justifyContent: "flex-end", height: 40 }}
        className="d-flex ac-js"
      >
        <div onClick={toggleSidebar}>
          {saideBarShow ? (
            <KeyboardDoubleArrowLeftIcon className="arrow-right" />
          ) : (
            <KeyboardDoubleArrowRightIcon className="arrow-left" />
          )}
        </div>
        <div
          style={{
            position: "relative",
            top: 22,
            right: -15,
          }}
          className="mx-3 "
        >
          {saideBarShow && filteredDropdown.length > 0 && (
           <div
  role="button"
  aria-label="menu"
  style={{
    width: 25,
    height: 10,
    cursor: "pointer",
    backgroundColor: PRIMARY_COLOR,
    WebkitMaskImage: `url(${side_bar})`,
    WebkitMaskPosition: "center center",
    WebkitMaskSize: "contain",
    WebkitMaskRepeat: "no-repeat",
    maskImage: `url(${side_bar})`,
    maskPosition: "center center",
    maskSize: "contain",
    maskRepeat: "no-repeat",
  }}
  onClick={() => setShowMenu((prev) => !prev)}
/>
          )}
        </div>
      </div>
      {showMenu && filteredDropdown.length > 0 && (
        <>
          <div
            className="dropdown-overlay"
            onClick={() => setShowMenu(false)}
          ></div>
          <div style={{ width: "120%" }} className="dropdown-menu-custom">
            {filteredDropdown.map((item, index) => (
              <div
                key={index}
                className={
                  index === filteredDropdown.length - 1
                    ? "dropdown-item1"
                    : "dropdown-item"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  setShowMenu(false);
                  navigate(item.path);
                }}
              >
                <p className="f3 fs-sm-16 fs-md-15 fs-lg-16 primary mb-0">
                  {item.title}
                </p>
                <div
                  style={{
                    width: 6,
                    height: 12,
                    backgroundColor: PRIMARY_COLOR,
                    WebkitMaskImage: `url(${arrow})`,
                    WebkitMaskPosition: "center center",
                    WebkitMaskSize: "contain",
                    WebkitMaskRepeat: "no-repeat",
                    maskImage: `url(${arrow})`,
                    maskPosition: "center center",
                    maskSize: "contain",
                    maskRepeat: "no-repeat",
                  }}
                />              </div>
            ))}
          </div>
        </>
      )}

      <div ref={menuRef} className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            {filteredMenu.map((item, index) => (
              <li
                key={index}
                className="nav_link trans"
                onClick={() => handleMenuClick(item.module_code, item.path)}
              >
                <h4
                  className={` ${item.activePaths.includes(currentPath) ? "f3 active_bar" : ""}`}
                >
<div
  style={{
    width: 22,
    height: 22,
    backgroundColor: PRIMARY_COLOR,
    WebkitMaskImage: `url(${item.icon})`,
    WebkitMaskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
    WebkitMaskSize: "contain",
    maskImage: `url(${item.icon})`,
    maskRepeat: "no-repeat",
    maskPosition: "center",
    maskSize: "contain",
  }}
/>
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 d-flex ac-jb w-100">
                    {item.title}
                  </span>
                </h4>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Logout Button */}
      {saideBarShow && (
        <div className="d-flex ac-jb py-3 px-2 bg-primary2">
          <div
            className="d-flex ac-jc py-2 gap-1"
            onClick={() => setPopup(true)}
          >
            <div
              style={{
                width: 15,
                height: 15,
                backgroundColor: PRIMARY_COLOR,
                WebkitMaskImage: `url(${logout})`,
                WebkitMaskPosition: "center center",
                WebkitMaskSize: "contain",
                WebkitMaskRepeat: "no-repeat",
                maskImage: `url(${logout})`,
                maskPosition: "center center",
                maskSize: "contain",
                maskRepeat: "no-repeat",
              }}
            />
            <p className="f3 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-16 fs-xxl-19 logout_text primary">
              LOGOU
            </p>
          </div>
          {menuOpen ? (
            <KeyboardArrowUpIcon
              className="arrow-down "
              onClick={handleCloseMenu}
            />
          ) : (
            <KeyboardArrowDownIcon
              className="arrow-down "
              onClick={() => setMenuOpen(true)}
            />
          )}
        </div>
      )}

      {/* Logout Confirmation Popup */}
      {/* {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary1">
              Are you sure, you want to logout?
            </p>
            <div className="d-flex ac-jb px-2 mt-4 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => setPopup(false)} className="no-btn w-45">
                No
              </button>
              <button
                onClick={handleLogout}
                className="yes-btn f2 w-45 f3 fs-xs-14 fs-sm-15 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "black", padding: 6 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </div>
      )} */}

      <CommonPopup
        isOpen={popup}
        message="Are you sure, you want to logout?"
        onClose={() => setPopup(false)}
        onConfirm={handleLogout}
        loading={loading}
      />
    </div>
  );
};

export default ProfileNavbar;
